import { format, parse } from 'date-fns';

export const formatTime = (time?: string, timeFormat = 'h:mmaaaaa') => {
  if (!time) return '';
  const inputDate = parse(time, 'HH:mm', new Date());
  return format(inputDate, timeFormat);
};
